module.exports = __webpack_public_path__ + "img/DAY1-1.361a667a.jpg";